module.exports = __webpack_public_path__ + "img/logo-portal.8def05bb.svg";